<template>
  <v-dialog
    v-model="isOpen"
    persistent
    max-width="400px"
  >
    <v-alert
      :value="true"
      color="white"
      class="text-md-center pb-2 pt-2 black--text">
      <div>
        <div class="body text-md-left">検査ステータスの変更</div>
        <v-divider
          class="mt-2"
        />
        <div class="headline mt-5">検査を開始しますか？</div>
        <br>
        <v-btn
          id="start-inspection"
          :loading="!dataLoaded"
          class="mt-3"
          large
          dark
          color="primary lighten-1"
          @click.native="setClientArrived"
        >
          はい
        </v-btn>
        <v-btn
          class="mt-3"
          large
          dark
          outline
          color="red lighten-1"
          to="/search"
        >
          キャンセル
        </v-btn>
        <cp-appointment-summary
          :appointment="appointment"
          class="body text-md-left pt-2"
        />
      </div>
    </v-alert>
  </v-dialog>
</template>

<script>
import gql from 'graphql-tag';
import { aiInspectionStatuses } from '../options';

export default {
  props: {
    dialog: {
      type: Boolean,
      default: true,
    },
    appointment: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isOpen: this.dialog,
      dataLoaded: true,
    };
  },
  watch: {
    dialog(v) {
      this.isOpen = v;
    },
  },
  methods: {
    setClientArrived() {
      this.dataLoaded = false;
      const appId = parseInt(this.$route.params.id, 10);

      this.$apollo.mutate({
        mutation: gql`
          mutation($appointmentId: Int!) {
            clientArrivedToInspection(appointmentId: $appointmentId)
          }`,
        variables: {
          appointmentId: appId,
        },
        refetchQueries: ['meetingTookPlace'],
      }).then(() => {
        this.isOpen = false;
        this.dataLoaded = true;
        this.clientArrived = true;

        this.$store.commit('setAiInspectionStatus', {
          apollo: this.$apollo,
          appId,
          status: aiInspectionStatuses.INSPECTION_STARTED });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ArrivedDialog.vue